import React from "react";
import { getStyle } from "../../styles/styles";
import { Breadcrumb } from "antd";
import OrderDeliveryScreen from "./OrderDeliveryScreen";
import SettlementApplicationForm from "../deal/SettlementApplicationForm";
import { getLookUpTable } from "../../networking/Networking";
import { getCurrenciesDenominationsByCustomer } from "../../networking/NetworkingCurrencies";
import { getBankNoteOrder } from "../../networking/NetworkingBankNotes";

var style = getStyle();
export default class OrderSettlementScreen extends React.Component {
    state = {
        currencyID: '',
        customerID: 0,
        listInstruments : [],
        listActiveCurrencies : [],
        lockedSide: 'Sell',
        orderAmount: 0,
        step: 1,
    }

    componentDidMount(){
        this.loadInstruments();
        this.loadOrder();
    }
    
    handleBackLink() {
        this.props.backLink();
    }

    async loadCurrencyList(customerId) {
        const currenciesResponse = await getCurrenciesDenominationsByCustomer(customerId);
        if(currenciesResponse && currenciesResponse.currencies) {
            const formattedCurrencies = currenciesResponse.currencies.map(c => ({ ...c, name: c.CurrencyIDName, value: c.CurrencyID }));
            const finalCurrencies = [];
            formattedCurrencies.forEach(element => {
                switch (element.Type) {
                    case 'Settlement':
                        finalCurrencies.push(element);
                        break;
                    default:
                        break;
                }
            });
            finalCurrencies.forEach(element => {
                element.value = element.CurrencyID;
                element.name = element.CurrencyIDName;
            });
            this.setState({ listActiveCurrencies: finalCurrencies });
        }
    }

    loadInstruments(){
        getLookUpTable('Incoming Instruments').then(
            (response) => {
                if (typeof response !== "undefined" && response.lookUpTables !== "undefined") {
                    let instruments = response.lookUpTables[0];
                    instruments.lookUpTableDetails.forEach(element => {
                        element.value = element.LookUpTableDetail;
                        element.name = element.LookUpTableDetail;
                    });
                    var listInstruments = [];
                    listInstruments.push(instruments);
                    this.setState({
                        listInstruments: listInstruments
                    });                    
                }
            }
        );
    }

    async loadOrder(){
        const order = await getBankNoteOrder(this.props.data);
        if (order && order.CustomerId > 0){
            this.setState({customerID: order.CustomerId, lockedSide: order.BuySell, currencyID: order.SettlementCurrencyID, orderAmount: order.PendingAmount})
        }
    }
    
    onClickStepTab = (value) => {
        /*if(this.state.step === 1){
            //Nothing at all
        }
        else{*/
            this.setState({step: value});            
        //}
    }

    render() {
        var stepScreen = [];

        var classNameStep1 = '', classNameStep2 = '';

        switch(this.state.step){
            case 1:
            default:
                classNameStep1 = 'uk-active';
                stepScreen.push(<OrderDeliveryScreen mainTitle={this.props.mainTitle} data={this.props.data}/>)
                break;
            case 2:
                classNameStep2 = 'uk-active';
                stepScreen.push(<SettlementApplicationForm key="oss-settlement-form"
                    customerID={this.state.customerID}
                    activeCurrencies={this.state.listActiveCurrencies}
                    incomingInstruments={this.state.listIncomingInstruments}
                    settlementOpenFromBoard={false}
                    lockedSide={this.state.lockedSide}
                    currencyID={this.state.currencyID}
                    orderAmount={this.state.orderAmount}
                />)
                break;
        }

        var orderTittle =  (
            <h3 className="uk-heading-divider" style={style.titleStyle} >
                <button className="uk-button uk-button-text uk-margin-small-right min-width-0" onClick={this.handleBackLink.bind(this)}>
                    <i className="fa fa-arrow-left back-arrow-white"></i>
                </button>
                ORDER INFORMATION
            </h3>);
        if (this.props.mainTitle != null) {
            orderTittle = '';
        }

        var currentScreen = (<div>
            {orderTittle}
            <div>
                <ul className="uk-tab">
                    <li className={classNameStep1}><a onClick={() => this.onClickStepTab(1)}>ORDER INFORMATION</a></li>
                    <li className={classNameStep2}><a onClick={() => this.onClickStepTab(2)}>SETTLEMENT INFORMATION</a></li>
                </ul>
                {stepScreen}
            </div>
        </div>)

        return (
            <div>
                <div className="breadcrumb-div">
                    <Breadcrumb separator=">">
                        <Breadcrumb.Item className="breadcrumb-item" onClick={this.handleBackLink.bind(this)}>{this.props.mainTitle}</Breadcrumb.Item>
                        <Breadcrumb.Item className="breadcrumb-item-bold">ORDER INFORMATION</Breadcrumb.Item>
                    </Breadcrumb>
                </div>
                {currentScreen}
            </div>
        )
    }
}